import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import 'firebase/storage';

// firebase init goes here
const config = {
    apiKey: "AIzaSyBr3Xm7O9etsVGRCyULZsCzAwC5yINFuUg",
    authDomain: "maintenance-19c7a.firebaseapp.com",
    databaseURL: "https://maintenance-19c7a.firebaseio.com",
    projectId: "maintenance-19c7a",
    storageBucket: "maintenance-19c7a.appspot.com",
    messagingSenderId: "660292868181"
}

 var app = firebase.initializeApp(config)

// firebase utils
const fs = app.firestore() //firestore database
const auth = app.auth()
const currentUser = auth.currentUser
const storage = app.storage().ref();

const settings = {
    timestampsInSnapshots: true
}
fs.settings(settings)

// firebase collections
const usersCollection = fs.collection('users')
const devicesCollection = fs.collection('devices')

export {
    auth,
    currentUser,
    usersCollection,
    devicesCollection,
    storage
}


// WEBPACK FOOTER //
// ./src/firebaseConfig.js